import Input from "../../components/Input/Input";
import { FaChalkboardTeacher } from "react-icons/fa";
import Button from "../../components/Button/Button";

const TeacherFilter = ({ name, handleInputChange, info, setInfo, isBulk, setIsBulk,
  downloadTeacherExcel, permissions }) => {
  return (
    <div className="main-title-page page-title d-flex justify-content-space-between">
      <div className="col-md-3">
        <FaChalkboardTeacher />
        <span className="mx-2">Subject Teacher Mapping</span>
      </div>
      <div className="col-md-5">
        <Input
          type="text"
          className="form-control"
          value={name}
          placeholder="Search by name..."
          onChange={handleInputChange} // Use debounced input handler
          autoFocus
        />
      </div>
      <div className="col-md-4 mx-2">
        <Button
          type="submit"
          variant="info"
          className="mx-1 text-white"
          onClick={() => setInfo(!info)}
        >
          i
        </Button>
        {permissions.includes("bulk.upload.teacher.class.subject") && (
          <Button
            type="submit"
            variant="primary"
            onClick={() => setIsBulk(!isBulk)}
          >
            {!isBulk ? "Bulk Upload" : "User List"}
          </Button>
        )}
        {!isBulk &&
          <Button
            type="submit"
            variant="primary"
            className="mx-1"
            onClick={downloadTeacherExcel}
          >
            Download
          </Button>
        }
      </div>
    </div>
  );
};

export default TeacherFilter;
